var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 23.1602L13.4453 21.6602",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 0.0800781V1.68066H14.0254V2.63672H12.4219V4.24023H11.4658V2.63672H9.86523V1.68066H11.4658V0.0800781H12.4219Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80865 19.1602H0.875V4.16016H5.90817C7.35367 4.16016 8.59538 4.46045 9.63329 5.06104C10.6759 5.65674 11.4769 6.51367 12.0361 7.63184C12.5954 8.75 12.875 10.0879 12.875 11.6455C12.875 13.208 12.593 14.5508 12.029 15.6738C11.4698 16.7969 10.6617 17.6587 9.60486 18.2593C8.55272 18.8599 7.28732 19.1602 5.80865 19.1602ZM3.51244 16.8091H5.68069C6.69491 16.8091 7.54088 16.6187 8.2186 16.2378C8.89633 15.8521 9.40581 15.2783 9.74704 14.5166C10.0883 13.75 10.2589 12.793 10.2589 11.6455C10.2589 10.498 10.0883 9.5459 9.74704 8.78906C9.40581 8.02734 8.90107 7.4585 8.23282 7.08252C7.56931 6.70166 6.74467 6.51123 5.75889 6.51123H3.51244V16.8091Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDPlus);
export default __webpack_public_path__ + "static/media/d-plus.f4ddefb323ece4778c773474d1c31252.svg";
export { ForwardRef as ReactComponent };